<template>
    <section class="w-screen h-screen fixed inset-0 flex justify-center items-center z-50">
        <div v-if="showModal" class="absolute inset-0 bg-black bg-opacity-50" @click="closeModal"></div>
        <div id="modal modal-customer" class="modal absolute block w-5/6 sm:w-9/12 md:w-5/12 bg-white shadow-md rounded-lg" :class="{
            'animate__animated animate__zoomIn': showModal,
            'animate__animated animate__zoomOut': !showModal,
        }">
            <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Cash Register</h5>
            </div>
            <div id="modal-body" class="p-5">
                <InputRupiah v-model="saldo" id="saldo-awal" :label="label" input_class="w-full" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="closeModal" />
                    <SubmitButton id="submit" button_name="Submit"
                        button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="$emit('submitCashRegister', saldo)" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import InputRupiah from '@/components/form/InputRupiah.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';

export default {
    name: "ModalCashRegister",
    props: {
        label: {
            type: String,
            default: 'Saldo Awal',
        }
    },
    components: {
        // Add any components used in the template
        InputRupiah, SubmitButton
    },
    data() {
        return {
            saldo: 0,
            showModal: true,
        };
    },
    created() {
        console.log('modal is live');
    },
    methods: {
        closeModal() {
            this.showModal = false;
            setTimeout(() => {
                this.$emit('closeModal');
            }, 200);
        }
    },
};
</script>